<template>
  <page-header
    :breadcrumRoutes="routes"
    title="Formulario de baja de cargas individual"
  />

  <a-card class="mb-2">
    <a-row>
      <a-col>
        <a-typography-title class="text-gray-8" :level="4">
          Datos corporativos
        </a-typography-title>
      </a-col>
    </a-row>
    <a-form
      name="form"
      layout="vertical"
      ref="formRef"
      :model="formState"
      :rules="rules"
    >
      <a-row :gutter="[16, 4]" type="flex">
        <a-col :xs="24" :md="8">
          <a-form-item label="RUT titular" has-feedback name="rut">
            <input-rut
              v-model="formState.rut"
              @change="rutChange"
              @keyup="formatRuts"
            />
          </a-form-item>
        </a-col>
        <a-col :xs="24" :md="8">
          <a-form-item label="Fecha afecto" has-feedback name="affectDate">
            <a-date-picker
              :format="dateFormat"
              placeholder="DD-MM-AAAA"
              :style="{ width: '100%' }"
              v-model:value="formState.affectDate"
            />
          </a-form-item>
        </a-col>
        <a-row justify="space-between"></a-row>
        <a-col :xs="24" :md="12">
          <a-form-item label="Empresa" name="company" has-feedback>
            <select-ordered
              placeholder="Selecciona una empresa"
              v-model="formState.company"
              :options="dataCompany"
              :disabled="blockCompany"
              @change="loadInsurance"
            />
          </a-form-item>
        </a-col>
        <a-col :xs="24" :md="12">
          <a-form-item label="Aseguradora" name="insurance" has-feedback>
            <select-ordered
              placeholder="Selecciona una aseguradora"
              v-model="formState.insurance"
              :options="dataInsurance"
              :disabled="blockInsurance"
              @change="loadPolicy"
            />
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="16" type="flex" class="mb-3">
        <a-col :xs="24" :md="8">
          <a-form-item label="Pólizas" name="policy" has-feedback>
            <select-ordered
              placeholder="Selecciona una póliza"
              v-model="formState.policy"
              :disabled="blockPolicy"
              :options="dataPolicy"
              mode="multiple"
            />
          </a-form-item>
        </a-col>
        <a-col :xs="24" :md="8">
          <a-form-item label="Cargas" name="dependents" has-feedback>
            <select-ordered
              placeholder="Selecciona las cargas"
              v-model="formState.dependents"
              :options="dataDependents"
              mode="multiple"
            />
          </a-form-item>
        </a-col>
      </a-row>
      <a-typography-title class="text-gray-8" :level="4">
        Mensaje a compañía aseguradora
      </a-typography-title>

      <a-row class="mb-2" :gutter="[16, 4]">
        <a-col :xs="24" :md="12">
          <a-form-item
            has-feedback
            label="Escribe un mensaje para la compañía aseguradora"
            name="message"
          >
            <a-textarea
              v-model:value="formState.message"
              placeholder="Escribe aquí..."
              :rows="6"
            />
          </a-form-item>
        </a-col>
        <a-col :xs="24" :md="8">
          <a-form-item name="optionalFiles" label="Archivos opcionales">
            <a-upload
              :file-list="formState.optionalFiles"
              :multiple="true"
              :remove="handleRemoveOptional"
              :before-upload="beforeUploadOptional"
              accept=".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx"
            >
              <a-button>
                <upload-outlined />
                Subir Archivo
              </a-button>
            </a-upload>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
  </a-card>

  <a-row type="flex" class="justify-content-end">
    <a-col>
      <a-button
        size="large"
        class="px-4"
        type="primary"
        @click="formValidation"
      >
        Siguiente
      </a-button>
    </a-col>
  </a-row>

  <a-modal
    :wrapClassName="'modal-xs'"
    centered
    v-model:visible="visible"
    title="Resumen baja de cargas individual"
    @ok="handleOk"
    :closable="!loading"
    :maskClosable="false"
  >
    <template #footer>
      <a-row type="flex" justify="end">
        <a-col>
          <a-space>
            <a-button @click="handleOk" :disabled="loading">Cancelar</a-button>
            <a-button
              class="bg-blue-6"
              key="submit"
              type="primary"
              @click="onSubmit"
              :disabled="blockModal()"
              :loading="loading"
            >
              Enviar
            </a-button>
          </a-space>
        </a-col>
      </a-row>
    </template>
    <a-typography-title class="text-gray-8 fw-regular" :level="4">
      Datos colaborador
    </a-typography-title>
    <a-typography-title class="text-gray-8 fw-regular mb-4" :level="5">
      Revisa que los datos ingresados estén correctos.
    </a-typography-title>
    <a-descriptions class="mb-4" bordered>
      <a-descriptions-item label="RUT" :span="3">
        {{ formState.rut ? formState.rut : '' }}
      </a-descriptions-item>
      <a-descriptions-item label="Empresa" :span="3">
        {{
          formState.company >= 1
            ? dataCompany.find((x) => x.value === formState.company).label
            : ''
        }}
      </a-descriptions-item>
      <a-descriptions-item label="Aseguradora" :span="3">
        {{
          formState.company >= 1
            ? dataInsurance.find((x) => x.value === formState.insurance).label
            : ''
        }}
      </a-descriptions-item>
      <a-descriptions-item label="Pólizas" :span="3">
        {{
          formState.company >= 1
            ? dataPolicy
                .filter((e) => {
                  return formState.policy.find((f) => f == e.value);
                })
                .map((e) => e.label)
                .join()
            : ''
        }}
      </a-descriptions-item>
      <a-descriptions-item label="Cargas" :span="3">
        <ul style="margin: 0; padding: 0 0 0 8px">
          <li
            v-for="selectedDependentId in formState.dependents"
            :key="selectedDependentId"
          >
            {{
              dataDependents.find((d) => d.value == selectedDependentId)?.label
            }}
          </li>
        </ul>
      </a-descriptions-item>
    </a-descriptions>
  </a-modal>
  <template v-if="showSucess">
    <a-modal
      :wrapClassName="'modal-xs'"
      v-model:visible="showSucess"
      centered
      footer=""
      :maskClosable="false"
    >
      <a-result
        centered
        status="success"
        title="Ticket creado"
        :sub-title="
          createExclusionMsg ||
          'Tu ticket de baja de cargas individual ha sido creado con éxito.'
        "
      >
        <template #extra>
          <router-link
            class="justify-content-center d-flex"
            :to="{ name: 'BajaCargasDetalle', params: { id: iDticket } }"
          >
            <a-button key="console" type="primary">Ver ticket</a-button>
          </router-link>
        </template>
      </a-result>
    </a-modal>
  </template>
  <template v-if="showError">
    <a-modal
      :wrapClassName="'modal-xs'"
      v-model:visible="showError"
      centered
      footer=""
      :maskClosable="false"
    >
      <a-result
        centered
        status="error"
        title="Error"
        :sub-title="
          createExclusionError ||
          'No se ha podido generar el ticket. Asegúrate de que exista un Ticket de Alta generado previamente.'
        "
      >
        <template #extra>
          <a-button type="primary" @click="() => handleOk()">Cerrar</a-button>
        </template>
      </a-result>
    </a-modal>
  </template>
  <pending-policy-modal
    :visible="showPendingPolicyModal"
    :conflicts="pendingPolicyConflicts"
    ticket-type-label="baja de cargas"
    :employee-rut="formState.rut"
    ticket-route-name="BajaCargasDetalle"
    @update:visible="showPendingPolicyModal = $event"
  />
</template>

<script>
import { reactive, ref } from 'vue';
import { message } from 'ant-design-vue';
import moment from 'moment';
import { useStore } from 'vuex';
import PageHeader from '@/components/page-header.vue';
import InputRut from '@/bewell-components/form-controls/input-rut.vue';
import SelectOrdered from '@/bewell-components/form-controls/select-ordered.vue';
import { UploadOutlined } from '@ant-design/icons-vue';
import PendingPolicyModal from '@/components/tickets/PendingPolicyModal.vue';

import {
  GET_LOGGED_USER,
  FETCH_COMPANY_BY_RUT,
  FETCH_INSURANCECOMPANY_BY_RUT,
  FETCH_POLICY_INSURANCE_COMPANY,
  FETCH_DEPENDENTS_WITH_PARAMS,
  POST_DEPENDENTS_EXCLUSION
} from '@/store/types';
import rutHelper from '@/utils/Ruts';
import { FETCH_TABLE_TICKETS_TEST } from '@/store/ticket/datatable/types';
import { FETCH_DEPENDENTS_EXCLUSION_OF_TICKET } from '@/store/types';

const routes = [
  {
    path: '/bajas-cargas',
    breadcrumbName: 'Bajas cargas'
  },
  {
    breadcrumbName: 'Formulario individual'
  }
];

export default {
  name: 'BajaIndividual',
  components: {
    'page-header': PageHeader,
    'input-rut': InputRut,
    'select-ordered': SelectOrdered,
    'upload-outlined': UploadOutlined,
    PendingPolicyModal
  },
  setup() {
    const formRef = ref();
    const formState = reactive({
      rut: '',
      company: null,
      insurance: null,
      message:
        'A través este medio solicitamos la siguente baja de cargas para el titular de RUT:',
      optionalFiles: [],
      policy: [],
      affectDate: '',
      dependents: []
    });
    const dateFormat = 'DD-MM-YYYY';
    const showError = ref(false);
    const showSucess = ref(false);
    const loading = ref(false);
    // Block Selects
    const blockCompany = ref(true);
    const blockInsurance = ref(true);
    const blockPolicy = ref(true);
    // Consumo Data
    const dataCompany = ref([]);
    const dataInsurance = ref([]);
    const dataPolicy = ref([]);
    const dataDependents = ref([]);
    const searchingRut = ref(false);
    const showPendingPolicyModal = ref(false);
    const pendingPolicyConflicts = ref([]);

    const formatRuts = () => {
      formState.rut = rutHelper.formatRut(formState.rut);
    };

    // Validations
    const checkCompany = async (rule, value) => {
      if (!value) {
        const errorMessage = 'Seleccione una empresa';
        return Promise.reject(errorMessage);
      }
      return Promise.resolve();
    };
    const checkInsurance = async (rule, value) => {
      if (!value) {
        const errorMessage = 'Seleccione una aseguradora';
        return Promise.reject(errorMessage);
      }
      return Promise.resolve();
    };

    // * RUT
    const valid_rut = ref(false);
    const checkRut = async (rule, value) => {
      if (!value) {
        const errorMessage = 'Ingrese RUT';
        valid_rut.value = false;
        return Promise.reject(errorMessage);
      }
      if (!rutHelper.validateRut(value)) {
        valid_rut.value = false;
        return Promise.reject('RUT no válido');
      }
      const data = await getCompanyByRut(rutHelper.normalizeRut(value));
      await fetchDependents(rutHelper.normalizeRut(value));

      if (!data) {
        valid_rut.value = false;
        return Promise.reject('No se encuentra el RUT');
      }
      valid_rut.value = true;
      return Promise.resolve();
    };

    const fetchDependents = async (employeeRut) => {
      searchingRut.value = true;
      return await store
        .dispatch(FETCH_DEPENDENTS_WITH_PARAMS, {
          employeeRut: rutHelper.normalizeRut(employeeRut),
          dependentStatus: 'active'
        })
        .then((dependents) => {
          const normalizedEmployeeRut = rutHelper.normalizeRut(employeeRut);
          dataDependents.value = dependents.map((d) => {
            const relatedEmployeeDependent =
              d.employeeDependents?.find(
                (ed) =>
                  rutHelper.normalizeRut(ed?.employee?.rut) ===
                  normalizedEmployeeRut
              ) ?? d.employeeDependents?.[0];
            return {
              value: d.id,
              label: d.rut,
              ticketId: relatedEmployeeDependent?.ticketId ?? null
            };
          });
          blockCompany.value = false;
          searchingRut.value = false;
          return dependents;
        })
        .catch((error) => {
          console.error(error);
          searchingRut.value = false;
          valid_rut.value = false;
          // Valores de la empresa a vacios
          blockCompanySelect();
          // Valores de aseguradora a vacios
          blockInsuranceSelect();
          // Valores de las polizas a vacios
          blockPolicySelect();
        });
    };

    const getCompanyByRut = async (val) => {
      searchingRut.value = true;
      return await store
        .dispatch(FETCH_COMPANY_BY_RUT, rutHelper.normalizeRut(val))
        .then((response) => {
          dataCompany.value = response.data.map((a) => {
            return {
              value: a.id,
              label: a.businessName
            };
          });
          blockCompany.value = false;
          searchingRut.value = false;
          return response.data;
        })
        .catch((error) => {
          console.error(error);
          searchingRut.value = false;
          valid_rut.value = false;
          // Valores de la empresa a vacios
          blockCompanySelect();
          // Valores de aseguradora a vacios
          blockInsuranceSelect();
          // Valores de las polizas a vacios
          blockPolicySelect();
        });
    };

    // * Bloqueo de inputs

    const blockCompanySelect = () => {
      // formState.company = '';
      dataCompany.value.length = 0;
      blockCompany.value = true;
    };

    const blockInsuranceSelect = () => {
      // formState.insurance = '';
      dataInsurance.value.length = 0;
      blockInsurance.value = true;
    };

    const blockPolicySelect = () => {
      formState.policy = [];
      dataPolicy.value.length = 0;
      blockPolicy.value = true;
    };

    const rules = {
      company: [
        {
          required: true,
          validator: checkCompany,
          trigger: 'change'
        }
      ],
      insurance: [
        {
          required: true,
          validator: checkInsurance,
          trigger: 'change'
        }
      ],
      policy: [
        {
          type: 'array',
          required: true,
          message: 'Seleccione una póliza',
          trigger: 'change'
        }
      ],
      affectDate: [
        {
          required: true,
          message: 'Seleccione una fecha',
          trigger: 'change',
          type: 'object'
        }
      ],
      rut: [
        {
          required: true,
          validator: checkRut,
          trigger: 'change'
        }
      ],
      dependents: [
        {
          required: true,
          type: 'array',
          message: 'Seleccione al menos una carga',
          trigger: 'change'
        }
      ]
    };

    const rutChange = () => {
      if (formState.company > 0) {
        formRef.value.resetFields(['company', 'insurance', 'policy']);
      }
    };

    const loadInsurance = async (value) => {
      try {
        formState.insurance = null;
        formState.policy = null;
        if (formState.insurance == null) {
          formRef.value.resetFields(['insurance', 'policy']);
          blockPolicy.value = true;
        }
        const response = await store.dispatch(FETCH_INSURANCECOMPANY_BY_RUT, {
          payload: rutHelper.normalizeRut(formState.rut),
          companyId: value
        });
        if (response.data.length == 0) {
          blockCompany.value = true;
          blockInsurance.value = true;
          blockPolicy.value = true;
          message.error(
            `El empleado ${rutHelper.normalizeRut(
              formState.rut
            )} no está vigente en la empresa`
          );
          blockInsurance.value = true;
        } else {
          dataInsurance.value = response.data.map((a) => {
            return {
              value: a.id,
              label: a.businessName
            };
          });
          blockInsurance.value = false;
        }
      } catch (error) {
        blockInsurance.value = true;
        console.log(error);
      }
    };

    const loadPolicy = async () => {
      try {
        if (formState.policy.length > 0) {
          formRef.value.resetFields(['policy']);
        }
        if (dataPolicy.value.length > 0) {
          dataPolicy.value.splice(0);
        }
        if (formState.insurance) {
          formState.policy = [];
        }
        const response = await store.dispatch(FETCH_POLICY_INSURANCE_COMPANY, {
          company: formState.company,
          insurance: formState.insurance,
          rut: rutHelper.normalizeRut(formState.rut)
        });
        if (response.data) {
          dataPolicy.value = response.data
            .map((a) => {
              return {
                value: a.id,
                label: `${a.numberPolicy}`
              };
            })
            .filter((p) => p.label !== '370018-1'); // temporal fix for bice vida bug
          blockPolicy.value = false;
        }
      } catch (error) {
        console.log(error);
      }
    };

    const handleRemoveOptional = (file) => {
      const index = formState.optionalFiles.indexOf(file);
      const newFileList = formState.optionalFiles.slice();
      newFileList.splice(index, 1);
      formState.optionalFiles = newFileList;
    };

    const beforeUploadOptional = (file) => {
      const MAX_FILES = 5;
      const MAX_FILE_SIZE_BYTES = 5 * 1024 * 1024;

      if (formState.optionalFiles.length >= MAX_FILES) {
        message.error('Solo puedes subir un máximo de 5 archivos');
        return false;
      }
      if (file.size > MAX_FILE_SIZE_BYTES) {
        message.error('El archivo debe ser menor a 5MB');
        return false;
      }

      formState.optionalFiles = [...formState.optionalFiles, file];
      return false;
    };

    /* modal */
    const visible = ref(false);

    const showModal = () => {
      visible.value = true;
    };

    const handleOk = () => {
      visible.value = false;
      showError.value = false;
    };

    const blockModal = () => {
      let blocked = true;
      if (
        formState.rut.length > 1 &&
        formState.company >= 1 &&
        formState.insurance >= 1 &&
        formState.affectDate !== ''
      ) {
        blocked = false;
      }
      return blocked;
    };

    // * Crear un ticket de alta
    const iDticket = ref('');
    const store = useStore();
    const createExclusionError = ref('');
    const createExclusionMsg = ref('');
    const getLastTicketState = (ticket) => {
      if (ticket?.states?.length) {
        return [...ticket.states]
          .sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt))
          .at(-1);
      }
      if (ticket?.state) {
        return ticket.state;
      }
      return ticket?.state ?? null;
    };

    const isTicketPending = (ticket) => {
      if (ticket?.isRequesting === true || ticket?.state === 'requested') {
        return true;
      }
      const lastState = getLastTicketState(ticket);
      const stateId =
        lastState?.stateId ?? lastState?.id ?? lastState?.state?.id;

      if (stateId === undefined || stateId === null) return false;

      return stateId !== 3 && stateId !== 4;
    };

    const normalizePolicyValue = (value) => {
      if (value === null || value === undefined) return '';
      return String(value).trim().toLowerCase();
    };

    const extractTicketPolicies = (ticket) => {
      const policies =
        ticket?.policies ??
        ticket?.ticket?.policies ??
        ticket?.data?.policies ??
        [];
      if (Array.isArray(policies)) {
        return policies
          .map((p) => p?.id ?? p?.policyId ?? p?.numberPolicy ?? p)
          .map(normalizePolicyValue)
          .filter(Boolean);
      }
      return [normalizePolicyValue(policies)].filter(Boolean);
    };

    const checkPendingPolicies = async () => {
      if (
        !Array.isArray(formState.policy) ||
        formState.policy.length === 0 ||
        !Array.isArray(formState.dependents) ||
        formState.dependents.length === 0
      ) {
        pendingPolicyConflicts.value = [];
        return false;
      }

      const policyLabelsById = new Map(
        (Array.isArray(dataPolicy.value) ? dataPolicy.value : []).map((p) => [
          p.value,
          p.label
        ])
      );

      const policyLabelByKey = new Map();
      (Array.isArray(dataPolicy.value) ? dataPolicy.value : []).forEach((p) => {
        const normalizedId = normalizePolicyValue(p.value);
        const normalizedLabel = normalizePolicyValue(p.label);
        if (normalizedId) policyLabelByKey.set(normalizedId, p.label);
        if (normalizedLabel) policyLabelByKey.set(normalizedLabel, p.label);
      });

      const selectedPolicyKeys = formState.policy.flatMap((id) => {
        const normalizedId = normalizePolicyValue(id);
        const label = policyLabelsById.get(id);
        const normalizedLabel = normalizePolicyValue(label);
        return [normalizedId, normalizedLabel].filter(Boolean);
      });

      const selectedDependents = (
        Array.isArray(dataDependents.value) ? dataDependents.value : []
      ).filter((d) => formState.dependents.includes(d.value));

      const conflicts = [];

      const resp = await store.dispatch(
        FETCH_TABLE_TICKETS_TEST,
        `type=${encodeURIComponent(
          'Bajas de cargas'
        )}&employeeRut=${rutHelper.normalizeRut(
          formState.rut
        )}&page=1&items_per_page=50`
      );

      const rows = resp?.data?.rows || [];
      const pendingRows = rows.filter(isTicketPending);

      const pendingChecks = pendingRows.map(async (row) => {
        const rowPolicies = extractTicketPolicies(row);
        const matchedPolicies = selectedPolicyKeys.filter((policyKey) =>
          rowPolicies.includes(policyKey)
        );
        if (matchedPolicies.length === 0) return;

        const dependentsResp = await store.dispatch(
          FETCH_DEPENDENTS_EXCLUSION_OF_TICKET,
          row.id
        );

        const ticketDependentsRuts = new Set(
          (Array.isArray(dependentsResp) ? dependentsResp : [])
            .map((d) => rutHelper.normalizeRut(d?.rut))
            .filter(Boolean)
        );

        const matchedLabels = matchedPolicies
          .map((key) => policyLabelByKey.get(key) || key)
          .filter(Boolean);

        selectedDependents.forEach((dependent) => {
          const normalizedRut = rutHelper.normalizeRut(dependent.label);
          if (!normalizedRut || !ticketDependentsRuts.has(normalizedRut))
            return;
          conflicts.push({
            id: `${row.id}-${dependent.value}`,
            policy: matchedLabels.join(', ') || '',
            ticketId: row.id,
            dependentRut: dependent.label
          });
        });
      });

      await Promise.all(pendingChecks);

      if (conflicts.length > 0) {
        pendingPolicyConflicts.value = conflicts;
        showPendingPolicyModal.value = true;
        return true;
      }

      pendingPolicyConflicts.value = [];
      return false;
    };

    const onSubmit = async () => {
      try {
        loading.value = true;

        const formData = new FormData();
        formData.append('rut', rutHelper.normalizeRut(formState.rut));
        formData.append('brokerId', store.getters[GET_LOGGED_USER].id);
        formData.append('companyId', formState.company);
        formData.append(
          'endDate',
          moment(formState.affectDate).startOf('day').toISOString()
        );
        formData.append('insuranceCompanyId', formState.insurance);
        formState.policy.forEach((policy) => {
          formData.append('policies[]', policy);
        });
        formState.optionalFiles.forEach((file) => {
          formData.append('file', file);
        });

        formState.dependents.forEach((dependent) => {
          formData.append('dependents[]', JSON.stringify(dependent));
        });
        formData.append('message', formState.message);
        const resp = await store.dispatch(POST_DEPENDENTS_EXCLUSION, formData);
        iDticket.value = resp.ticket.id;
        showSucess.value = true;
        const successMsg = resp.message;
        if (successMsg) {
          createExclusionMsg.value = successMsg;
        }
        formRef.value.resetFields();
      } catch (error) {
        console.log(error);
        const errMsg = error.response?.data?.message;
        if (errMsg) {
          createExclusionError.value = errMsg;
        }
        loading.value = false;
        showError.value = true;
      }
      visible.value = false;
      loading.value = false;
    };

    // * Validación de formulario
    const formValidation = () => {
      formRef.value
        .validate()
        .then(async () => {
          const hasPendingPolicy = await checkPendingPolicies();
          if (hasPendingPolicy) return;
          showModal();
        })
        .catch((error) => {
          console.log('Error', error);
        });
    };

    return {
      // Variables
      routes,

      formRef,
      formState,
      visible,
      showError,
      showSucess,
      loading,
      dateFormat,
      blockCompany,
      blockInsurance,
      blockPolicy,
      rules,
      dataCompany,
      dataInsurance,
      dataPolicy,
      iDticket,
      showPendingPolicyModal,
      pendingPolicyConflicts,
      // Methods
      blockModal,
      handleOk,
      showModal,
      onSubmit,
      loadInsurance,
      rutChange,
      loadPolicy,
      formValidation,
      formatRuts,
      value1: ref(),
      dataDependents,
      createExclusionError,
      createExclusionMsg,
      handleRemoveOptional,
      beforeUploadOptional
    };
  }
};
</script>
